<div #head [hidden]="!head.hasChildNodes()">
  <ng-content select="[head]"></ng-content>
</div>
<div *ngIf="!head.hasChildNodes()" (click)="logData(button.hasChildNodes())"
  class="flex flex-row items-center justify-between w-full">
  <div>
    <h3 [@first] class="text-2xl text-zen font-medium uppercase">
      {{ "txtSelectCriteria" | translate : language : ModuleNames.Shared }}
    </h3>
    <p [@child3] class="text-base text-zen text-opacity-60">
      {{
      "txt_optional_criteria_description"
      | translate : language : ModuleNames.Shared
      }}
    </p>
  </div>
  <div
    [TourStep]="tourKey?{title:'txt_Predefine_865' | translate:language:ModuleNames.Shared,text: 'txt_Selectfro_459' | translate:language:ModuleNames.Shared,order:2,tourKey:tourKey,on:(language | language )?'right':'left'}:undefined">
    <a *DemoAccount="'Button'; let isDemo=isDemo" [@child2] (click)="isDemo?'':criteriaAddFunction()"
      class="btn block cancel rounded leading-12 px-10 text-center">
      {{"txt_new_criteria"| translate:language:ModuleNames.Shared}}</a>
  </div>
</div>

<div class="min-h-screen-40" (click)="logData(survey)">
  <div class="flex flex-row flex-wrap -mr-2 -ml-2 w-full">
    <ng-container *ngFor="let criteria of criteriaList; let x = index">
      <div class="flex flex-col p-2 w-1/4" *ngIf="!criteria.isDeleted">
        <div class="flex flex-col justify-between gap-9 p-5 border-2 rounded-md relative group btn" [ngClass]="{
          'border-exp': criteriaIsSelected(criteria.key),
          'border-zen opacity-90': !criteriaIsSelected(criteria.key),
          'cursor-pointer': selection
        }" (click)="selection ? selectCriteria(criteria) : ''">
          <div class="flex flex-row justify-between items-center">
            <i class="text-zen fal text-3xl fa-sitemap"></i>
            <div class="flex flex-row justify-end gap-1">
              <i *ngIf="criteria.isCustom" (click)="criteriaAddFunction(criteria); $event.stopPropagation()"
                class="far fa-pen btn cancel w-10 leading-10 text-center rounded opacity-0 group-hover:opacity-100"></i>
              <i *ngIf="criteria.isCustom" (click)="criteriaToDelete = criteria; $event.stopPropagation()"
                class="far fa-trash btn delete w-10 leading-10 text-center rounded opacity-0 group-hover:opacity-100"></i>
              <i *ngIf="selection" [ngClass]="
                criteriaIsSelected(criteria)
                  ? 'far fa-check-circle text-exp'
                  : 'fal fa-circle text-zen'
              " class="text-3xl"></i>
            </div>
          </div>
          <div class="flex flex-row justify-between items-center">
            <h4 class="text-zen text-lg leading-10 truncate" [matTooltip]="extractNameLanguage(criteria.name)">
              {{ extractNameLanguage(criteria.name) }}
            </h4>
          </div>
        </div>
      </div>
    </ng-container>

  </div>
</div>
<div [@child4] class="flex flex-row justify-between bg-zen-blueaccent bg-opacity-5 px-5 rounded items-center h-12 my-3"
  *ngIf="survey" [TourStep]="tourKey ? tourRespondednt : undefined">
  <div class="flex flex-row text-zen-blueaccent items-center gap-2">
    <z-toggle [opposite]="true" [(ngModel)]="survey.predefinedMetrics" [label]="
        'txtRespondentsFillCriteria' | translate : language : ModuleNames.Shared
      " (ngModelChange)="surveyChange.emit(survey)"></z-toggle>
  </div>
  <!-- {{survey.predefinedMetrics}} -->
  <!-- <i (click)="criteria = false"
    class="fal fa-times  text-zen-blueaccent w-10 leading-10 text-center cursor-pointer"></i> -->
</div>

<z-modal [(open)]="criteriaAdd">
  <ng-container header>
    <div class="flex flex-row gap-2 items-center w-full">
      <i
        class="fal fa-clipboard-list text-white bg-exp shadow-xl rounded-full minw10 h-10 w-10 text-xl text-center leading-10"></i>
      <h4 class="text-2xl font-bold text-zen truncate">
        {{
        edited
        ? extractNameLanguage(newMetric.name)
        : ("txt_new_criteria" | translate : language : ModuleNames.Shared)
        }}
      </h4>
      <!-- <p class="text-sm text-zen">Please reupload the data file after fixing the validation errors.</p> -->
    </div>
  </ng-container>
  <ng-container body *ngIf="criteriaAdd">
    <z-translation-input [invalid]="invalid" [label]="'txtCriteriaName' | translate : language : ModuleNames.Shared"
      [maxCount]="mdCount" [required]="true" [language]="language"
      [supportedLanguages]="selectedEntity.ContentLanguages" [(ngModel)]="newMetric.name">
    </z-translation-input>
    <!-- <h5 class="is-size-6 uppercase">Criteria Name</h5>
                <input class="custom-input  box mt-2" type="text" placeholder="i.e. Job Grade"> -->

    <h4 class="text-zen uppercase mt-10">
      {{ "txt_answers" | translate : language : ModuleNames.Shared }}
    </h4>
    <h4 class="text-zen opacity-70 text-sm mb-2">
      {{
      "txt_answers_description" | translate : language : ModuleNames.Shared
      }}
    </h4>
    <!-- <input  *ngFor="let answer of answers" class="custom-input box mt-4" type="text" placeholder="Type an answer here..."> -->
    <ng-container *ngFor="let option of newMetric.options; let i = index">
      <div class="w-full flex flex-col" *ngIf="!option?.isDeleted">
        <div class="flex flex-row relative w-full pb-6">
          <!-- <div class="flex flex-col w-full" [matTooltip]="localize('txtFieldIsRequired')"
             [matTooltipClass]="'toolTipAlert'"
             [matTooltipDisabled]="extractNameLanguage(option.name) != '' || !vMetricOptions"
             [ngClass]="extractNameLanguage(option.name) == '' && vMetricOptions? ' alertLine' : '' ">
             <translation-input [maxCount]="mdCount" class="w-full" [language]="language"
               [inputName]=""txtQAnswer"| translate:language:ModuleNames.Shared" [translationField]="option.name" [showHeading]="false"
               [supportedLanguages]="this.selectedEntity.ContentLanguages">
             </translation-input>
             <h4 *ngIf="countWord(extractNameLanguage(option.name), mdCount)> 0"
               [ngClass]="countWord(extractNameLanguage(option.name), mdCount)>= mdCount?'text-zen-red': ''"
               class="text-xxs">
               {{countWord(extractNameLanguage(option.name), mdCount)}} {{"txtof"| translate:language:ModuleNames.Shared}} {{mdCount}}</h4>
           </div> -->
          <div class="flex flex-col w-full items-stretch">
            <z-translation-input [invalid]="invalid" [placeholder]="
                 'txtQAnswer' | translate : language : ModuleNames.Shared
               " [maxCount]="mdCount" [required]="true" [language]="language"
              [supportedLanguages]="selectedEntity.ContentLanguages" [(ngModel)]="option.name">
            </z-translation-input>
          </div>

          <div class="absolute w-full -top-4 flex h-0 flex-row justify-end">
            <i [matTooltip]="
                 'btn_delete' | translate : language : ModuleNames.Shared
               " (click)="deleteOption(option)"
              class="fal fa-times w-4 h-4 block rounded-full text-center leading-4 bg-zen bg-opacity-10 shadow-sm text-zen-red cursor-pointer text-xs"></i>
          </div>
        </div>
      </div>
    </ng-container>
    <br />
    <div class="flex flex-row justify-end">
      <a (click)="answerIncreaseClick()" class="btn cancel rounded-md px-8 py-4 uppercase">{{ "btn_add_option" |
        translate : language : ModuleNames.Shared }}</a>
    </div>
  </ng-container>
  <ng-container footer class="flex w-full flex-row justify-between">
    <a (click)="criteriaAdd = false; modalChange.emit(false)"
      class="btn cancel text-center rounded-md px-8 py-4 uppercase text-lg font-medium">{{ "btn_close" | translate :
      language : ModuleNames.Shared }}</a>
    <a (click)="updateMetric(newMetric)" class="btn exp rounded-md px-8 py-4 uppercase text-lg font-medium">{{
      "btn_save_criteria" | translate : language : ModuleNames.Shared }}</a>
  </ng-container>
</z-modal>


<z-modal [autoWidth]="true" [(open)]="deselectConfirmation">
  <ng-container header>
    <div class="flex flex-row gap-2 items-center w-full justify-between">
      <h4 class="text-lg font-medium text-zen">
        {{("txt_DeselectC_979" | translate : language : ModuleNames.Shared)}}</h4>
      <button zenButton styles="secondary icon-10" (click)="deselectConfirmation = false">
        <i class="fa-regular fa-times"></i>
      </button>
    </div>
  </ng-container>
  <ng-container body>
    <div class="flex flex-col gap-2 items-center max-w-md w-screen">
      <div class="w-12 h-12 flex justify-center items-center bg-exp/10 border-solid border-exp/20 rounded-full"
        [style.borderWidth.px]="6">
        <i class="fa-regular fa-exclamation text-exp" [style.fontSize.rem]="2"></i>
      </div>
      <p class="text-zen text-sm text-center">{{'txt_Bydeselec_913' | translate : language : ModuleNames.Shared}}</p>
    </div>
  </ng-container>
  <ng-container footer class="flex w-full flex-row justify-between">
    <button zenButton styles="secondary height-10" (click)="deselectConfirmation = false">
      {{'txt_close' | translate:language:ModuleNames.Shared}}
    </button>
    <button zenButton styles="exp height-10" (click)="deselectDirectManager()">
      {{'txt_Confirm_322' | translate:language:ModuleNames.Shared}}
    </button>
  </ng-container>
</z-modal>

<z-modal [autoWidth]="true" [(open)]="criteriaToDelete">
  <!-- <ng-container header>
    <div class="flex flex-row gap-2 items-center w-full justify-between">
      <h4 class="text-lg font-medium text-zen">
        {{("txt_DeselectC_979" | translate : language : ModuleNames.Shared)}}</h4>
      <button zenButton styles="secondary icon-10" (click)="deselectConfirmation = false">
        <i class="fa-regular fa-times"></i>
      </button>
    </div>
  </ng-container> -->
  <ng-container body>
    <div class="flex flex-col gap-4 items-center max-w-md w-screen">
      <div class="w-12 h-12 flex justify-center items-center bg-zen-red/10 border-solid border-zen-red/20 rounded-full"
        [style.borderWidth.px]="6">
        <i class="fa-regular fa-exclamation text-zen-red" [style.fontSize.rem]="1.75"></i>
      </div>
      <p class="text-zen text-base text-center">{{'txt_delete_criteria' | translate : language : ModuleNames.Common}}</p>
    </div>
  </ng-container>
  <ng-container footer class="flex w-full flex-row justify-between">
    <button zenButton styles="secondary height-10" (click)="criteriaToDelete = null">
      {{'txt_close' | translate:language:ModuleNames.Shared}}
    </button>
    <button zenButton styles="red height-10" (click)="deleteCriteria(criteriaToDelete)">
      {{'txt_Confirm_322' | translate:language:ModuleNames.Shared}}
    </button>
  </ng-container>
</z-modal>